import { BaseStore } from 'fluxible/addons';

export default class ContestStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.stage = null;
        this.lockState = null;
        this.paymentRequired = null;
    }

    init({ stage, lockState, paymentRequired }) {
        this.stage = stage;
        this.lockState = lockState;
        this.paymentRequired = paymentRequired;
    }

    getStage() {
        return this.stage;
    }

    getLockState() {
        return this.lockState;
    }

    isPaymentRequired() {
        return this.paymentRequired;
    }
}
ContestStore.storeName = 'ContestStore';



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/contest-store.js